import { createSelector } from 'reselect'

import { RootState } from 'redux/store'

const selectMousabilityOpen = createSelector(
  (state: RootState) => state.page.isMouseAbilityOpen,
  (isMouseAbilityOpen: boolean) => isMouseAbilityOpen
)

export default selectMousabilityOpen
